import axios from "axios";

const api = axios.create({
  baseURL:
    (process.env.REACT_APP_API_BASE_URL || "http://localhost:4000") + "/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("isAuth");
      }

      const errorMessage = data.msg || data.errors || "An error occurred";
      return Promise.reject(new Error(errorMessage));
    } else if (error.request) {
      return Promise.reject(
        new Error("Network error - please check your connection"),
      );
    } else {
      return Promise.reject(error);
    }
  },
);

export default api;
